import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config';
import { SavingProfileFormValues } from 'type/savingType';

import { PersonWishGoalDto } from 'graphql/generates';
import type { ApiResponse } from '@dvag/dfs-api-client';
import { versions } from './versions';
import { getApiClient } from './api-client';

export const personApi = () => {
  const baseURL = `${getEnvironmentApiUrls().person}/${versions.v3}`;
  const api = getApiClient(baseURL);

  const updateLastAccessedHouseholdList = (householdId: string) =>
    api.put<never, never[]>(`/household/${householdId}/last-accessed`, []);

  const copyWishAndGoal = async (
    personId: string,
    payload: {
      personIdList: string[];
    },
  ) =>
    api.post<Omit<PersonWishGoalDto, '__typename'>, { personIdList: string[] }>(
      `/person/${personId}/wish-goal/copy`,
      payload,
    );

  const createSaverProfile = async (
    payload: SavingProfileFormValues,
    householdId: string | undefined,
  ): Promise<ApiResponse<SavingProfileFormValues>> =>
    api.post<SavingProfileFormValues>(`/household/${householdId}/saver-profile`, payload);

  const updateSaverProfile = async (
    householdId: string | undefined,
    payload: SavingProfileFormValues,
  ) =>
    api.put<SavingProfileFormValues, SavingProfileFormValues>(
      `household/${householdId}/saver-profile`,
      payload,
    );

  return {
    updateLastAccessedHouseholdList,
    copyWishAndGoal,
    createSaverProfile,
    updateSaverProfile,
  };
};
